import { Center, Container, Title } from '@mantine/core'
import Loader from 'common/Loader'
import FabricTable from 'components/productDetails/FabricTable'
import PillowTable from 'components/productDetails/PillowTable'
import PremadeTable from 'components/productDetails/PremadeTable'
import TableTable from 'components/productDetails/TableTable'
import TowelTable from 'components/productDetails/TowelTable'
import { useProductsOnPlace } from 'hooks/products'
import { Category, ProductWithVariants } from 'types/products'
import { getCategoryName } from 'utils'

type Props = {
  placeId: string | null
}

export default function ProductsOnPlaceTables({ placeId }: Props) {
  const { data: products, isFetching } = useProductsOnPlace(placeId)

  function getVariants(products: Array<ProductWithVariants>, category: Category) {
    return products
      .map((product) => {
        return (
          product.variants[category].map((variant) => ({
            ...variant,
            product: { id: product.id, symbol: product.symbol },
          })) || []
        )
      })
      .flat()
  }

  function getTable(category: Category) {
    switch (category) {
      case Category.FABRIC:
        return FabricTable
      case Category.PILLOW:
        return PillowTable
      case Category.PREMADE:
        return PremadeTable
      case Category.TOWEL:
        return TowelTable
      case Category.TABLE:
        return TableTable
      default: {
        const _exhaustiveCheck: never = category
        throw new Error(`Unhandled category: ${_exhaustiveCheck}`)
      }
    }
  }

  if (isFetching) {
    return <Loader />
  } else if (products && products.length > 0) {
    return [Category.PREMADE, Category.FABRIC, Category.PILLOW, Category.TOWEL, Category.TABLE].map((category) => {
      const variants = getVariants(products, category)
      if (variants.length === 0) return null

      const Table = getTable(category)

      return (
        <Container key={category} mt="xl" m={0} fluid>
          <Title order={3} my="lg">
            {getCategoryName(category).header}
          </Title>
          {/* @ts-ignore */}
          <Table variants={variants} />
        </Container>
      )
    })
  } else if (placeId) {
    return (
      <Center mt="xl">
        <Title order={2} c="dimmed" mt="xl" pt="xl" mb={0}>
          Wybrana półka jest pusta
        </Title>
      </Center>
    )
  }
  return null
}
